import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type SegmentBox } from 'entities/Segment'
import {
  type EnumEnrollmentMode,
  type IApplyChangeModal,
} from 'widgets/ContactEnrollment/store/types'
import { type FilterEditorStore } from 'widgets/FilterEditor'
import { type EnrollmentListStore } from 'widgets/ContactEnrollment/store'
import { EnrollmentFilterTab } from '../EnrollmentFilterTab/EnrollmentFilterTab'

type IEnrollmentIncludeProps = {
  enrollmentListStore: EnrollmentListStore
  filterEditorStore: FilterEditorStore
  segmentBox: SegmentBox
  mode: EnumEnrollmentMode
  showList?: boolean
  applyChangeModal: IApplyChangeModal
}

export const EnrollmentInclude: FC<IEnrollmentIncludeProps> = observer(
  ({ enrollmentListStore, filterEditorStore, segmentBox, mode, showList, applyChangeModal }) => (
    <EnrollmentFilterTab
      items={enrollmentListStore.allFiltersWithCount}
      preview={enrollmentListStore.preview}
      addOrUpdateItem={enrollmentListStore.addOrUpdateItem}
      searchDropdownStore={enrollmentListStore.searchDropdownStore}
      filterEditorStore={filterEditorStore}
      segmentBox={segmentBox}
      mode={mode}
      showList={showList}
      applyChangeModal={applyChangeModal}
    />
  )
)
